import angular from 'angular';
import config from 'app/config';

import UnsafeFilter from './unsafe.filter';

export default angular
.module(`${config.appName}.commonFilters`, [])
.filter('unsafe', UnsafeFilter.instance())
.name;
